module.exports = __webpack_public_path__ + "img/niu.433deb3d.svg";